// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// import ProgressStepper from "../visitConstant/ProgressSteppers/ProgressStepper";
// import UserSearchDropdown from "../CustomDropdown/UserSearchDropdown";
// import apiHelper from "../ApiHelpar/apiHelper";
// import useDebounce from "../useDebounce/useDebounce";
// import { GRT_HOSPITA_BY_NAME_ID } from "../visitConstant/ApiConstant";
// import BranchSearchDropdown from "../BranchSearchDropDown/BranchSearchDropDown";
// import DrSearchDropDown from "../BranchSearchDropDown/DrSearchDropDown";

// const AddHospitalDoctor: React.FC = () => {
//   const navigate = useNavigate();

//   // State management with proper typing
//   const [selectedHospital, setSelectedHospital] = useState(null);
//   const [hospitalList, setHospitalList] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState(null);

//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [doctorList, setDoctorList] = useState([]);

//   // Credential states
//   const [userName, setUserName] = useState("");
//   const [password, setPassword] = useState("");

//   // UI states
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   // Search inputs
//   const [hospitalSearch, setHospitalSearch] = useState("");
//   const [doctorSearch, setDoctorSearch] = useState();

//   // Apply debouncing to search inputs
//   const debouncedHospitalSearch = useDebounce(hospitalSearch, 500);
//   const debouncedDoctorSearch = useDebounce(doctorSearch, 500);

//   // Clear error when inputs change
//   useEffect(() => {
//     if (error) setError("");
//   }, [selectedHospital, selectedBranch, selectedDoctor, userName, password]);

//   // Fetch hospitals based on search term
//   useEffect(() => {
//     if (debouncedHospitalSearch && debouncedHospitalSearch.trim() !== "") {
//       fetchHospitals();
//     } else {
//       setHospitalList([]);
//     }
//   }, [debouncedHospitalSearch]);

//   const fetchHospitals = async () => {
//     try {
//       setLoading(true);
//       const response = await apiHelper(GRT_HOSPITA_BY_NAME_ID, {
//         name: debouncedHospitalSearch,
//       });

//       console.log(response);
//       if (response.respData && Array.isArray(response.respData.respMsg)) {
//         setHospitalList(response.respData.respMsg);
//       } else {
//         setHospitalList([]);
//         console.error("Invalid hospital data format:", response);
//       }
//     } catch (err) {
//       console.error("Error fetching hospitals:", err);
//       setError("Failed to load hospitals. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch doctors based on search term
//   useEffect(() => {
//     if (debouncedDoctorSearch && debouncedDoctorSearch.trim() !== "") {
//       fetchDoctors();
//     } else {
//       setDoctorList([]);
//     }
//   }, [debouncedDoctorSearch]);

//   const fetchDoctors = async () => {
//     try {
//       setLoading(true);
//       const data = {
//         name: debouncedDoctorSearch,
//         // Include mobile search if needed
//         mobileNo: debouncedDoctorSearch.match(/^\d+$/)
//           ? debouncedDoctorSearch
//           : "",
//       };

//       const response = await apiHelper("searchDoctorByNameOrMobileNo", data);

//       if (response.respData && Array.isArray(response.respData.respMsg)) {
//         setDoctorList(response.respData.respMsg);
//       } else {
//         setDoctorList([]);
//         console.error("Invalid doctor data format:", response);
//       }
//     } catch (err) {
//       console.error("Error fetching doctors:", err);
//       setError("Failed to load doctors. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update when hospital is selected
//   useEffect(() => {
//     if (selectedHospital) {
//       setHospitalSearch(selectedHospital.name);
//     }
//   }, [selectedHospital]);

//   // Update doctor search when doctor is selected
//   useEffect(() => {
//     if (selectedDoctor) {
//       setDoctorSearch(selectedDoctor.name);

//       // Optionally set username based on doctor name
//       if (!userName) {
//         const suggestedUsername = selectedDoctor.name
//           .toLowerCase()
//           .replace(/\s+/g, ".");
//         setUserName(suggestedUsername);
//       }
//     }
//   }, [selectedDoctor]);

//   // Validate form data
//   const validateForm = (): boolean => {
//     if (!selectedHospital) {
//       setError("Please select a hospital");
//       return false;
//     }

//     if (!selectedBranch) {
//       setError("Please select a branch");
//       return false;
//     }

//     if (!selectedDoctor) {
//       setError("Please select a doctor");
//       return false;
//     }

//     if (!userName.trim()) {
//       setError("Username is required");
//       return false;
//     }

//     if (!password.trim()) {
//       setError("Password is required");
//       return false;
//     }

//     if (password.length < 6) {
//       setError("Password must be at least 6 characters long");
//       return false;
//     }

//     return true;
//   };

//   // Form submission handler
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const requestData = {
//         branchId: selectedBranch.id,
//         doctorID: selectedDoctor,
//         userName: userName,
//         password: password,
//         role: "ROLE_DOCTOR",
//         startDate: moment().format("YYYY-MM-DD"),
//       };

//       // console.log(requestData);
//       const response = await apiHelper("addHospitalDoctor", requestData);

//       if (response.respInfo.message == "Success") {
//         setSuccess("Doctor added successfully to the branch");

//         // Redirect after success
//         // setTimeout(() => {
//         //   navigate("/");
//         // }, 1500);
//       } else {
//         //  throw new Error(response.message || "Failed to add doctor");
//       }
//     } catch (err) {
//       console.error("Error adding doctor:", err);
//       setError(err.message || "Error adding doctor. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (setter) => (e) => {
//     setter(e.target.value);
//   };

//   // console.log(selectedBranch.id, "selectedHospital");

//   return (
//     <div className="justify-content-center  w-100 " style={{ maxWidth: 700 }}>
//       {/* <ProgressStepper currentSteps={4} /> */}
//       <div className="card mx-auto ">
//         <div className="card-header ">
//           <h4 className="mb-0">Add Doctor to Branch</h4>
//         </div>
//         <div className="card-body">
//           {error && <div className="alert alert-danger">{error}</div>}
//           {success && <div className="alert alert-success">{success}</div>}

//           <form onSubmit={handleSubmit}>
//             {/* Hospital Selection */}
//             <div className="mb-3">
//               <label className="form-label">Hospital*</label>
//               <UserSearchDropdown
//                 options={hospitalList}
//                 handleInputChange={setHospitalSearch}
//                 onSelect={setSelectedHospital}
//                 value={selectedHospital}
//                 loading={loading && debouncedHospitalSearch !== ""}
//                 Placeholder="Search hospital by name"
//                 searchTerm={hospitalSearch}
//                 newEntry={false}
//                 UserSearchDrop={false}
//                 displayKey={(option) => option?.name || ""}
//               />
//               {hospitalSearch && hospitalList.length === 0 && !loading && (
//                 <div className="form-text text-muted">
//                   No hospitals found. Try a different search term.
//                 </div>
//               )}
//             </div>

//             {/* Branch Selection */}
//             {/* <div className="mb-3">
//               <label htmlFor="branchSelect" className="form-label">
//                 Branch*
//               </label>
//               <select
//                 className="form-select"
//                 id="branchSelect"
//                 value={selectedBranch?.id || ""}
//                 onChange={(e) => {
//                   if (e.target.value) {
//                     const branchId = parseInt(e.target.value);
//                     const branch =
//                       selectedHospital?.branches.find(
//                         (b) => b.id === branchId
//                       ) || null;
//                     setSelectedBranch(branch);
//                   } else {
//                     setSelectedBranch(null);
//                   }
//                 }}
//                 required
//                 disabled={
//                   !selectedHospital || !selectedHospital.branches?.length
//                 }
//               >
//                 <option value="">Select Branch</option>
//                 {selectedHospital?.branches?.map((branch) => (
//                   <option key={branch.id} value={branch.id}>
//                     {branch.branchName} - {branch.branchAddress}
//                   </option>
//                 ))}
//               </select>
//               {selectedHospital &&
//                 (!selectedHospital.branches ||
//                   selectedHospital.branches.length === 0) && (
//                   <div className="form-text text-muted">
//                     This hospital has no branches. Please select a different
//                     hospital.
//                   </div>
//                 )}
//             </div> */}

//             <div className="mb-3">
//               <label htmlFor="branchSelect" className="form-label">
//                 Branch*
//               </label>

//               <BranchSearchDropdown
//                 hospitalId={selectedHospital?.id}
//                 onSelect={(e) => setSelectedBranch(e)}
//                 selectedBranchId={selectedBranch?.id}
//               />
//             </div>

//             {/* Doctor Selection */}
//             <div className="mb-3">
//               <label className="form-label">Doctor*</label>
//               {/* <UserSearchDropdown
//                 options={doctorList}
//                 handleInputChange={setDoctorSearch}
//                 onSelect={setSelectedDoctor}
//                 value={selectedDoctor}
//                 loading={loading && debouncedDoctorSearch !== ""}
//                 Placeholder="Search doctor by name or mobile"
//                 searchTerm={doctorSearch}
//                 newEntry={false}
//                 UserSearchDrop={false}
//                 displayKey={(option) =>
//                   `${option?.name || ""} ${
//                     option?.mobileNo ? `(${option.mobileNo})` : ""
//                   }`
//                 }
//               />
//               {doctorSearch && doctorList.length === 0 && !loading && (
//                 <div className="form-text text-muted">
//                   No doctors found. Try a different search term.
//                 </div>
//               )} */}

//               {/* <DrSearchDropDown
//                 onSelect={(e) => {

//                   doctorSearch(e);
//                 }}
//                 hospitalId={0}
//                 type="docotor"
//                 branchId={selectedBranch?.id}
//                 value={selectedDoctor}
//               /> */}
//             </div>

//             {/* Username Input */}
//             <div className="mb-3">
//               <label className="form-label">Username*</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={userName}
//                 onChange={handleInputChange(setUserName)}
//                 placeholder="Enter username for doctor login"
//                 required
//               />
//               <div className="form-text">
//                 Username will be used by the doctor to login to the system
//               </div>
//             </div>

//             {/* Password Input */}
//             <div className="mb-3">
//               <label className="form-label">Password*</label>
//               <input
//                 type="password"
//                 className="form-control"
//                 value={password}
//                 onChange={handleInputChange(setPassword)}
//                 placeholder="Enter password"
//                 required
//                 minLength={6}
//               />
//               <div className="form-text">
//                 Password must be at least 6 characters long
//               </div>
//             </div>

//             {/* Form Actions */}
//             <div className="d-grid gap-2 d-md-flex justify-content-md-end">
//               <button
//                 type="button"
//                 className="btn btn-outline-info me-md-2"
//                 onClick={() => navigate("/drsignup")}
//                 disabled={loading}
//               >
//                 Back
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-primary text-light"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <span
//                       className="spinner-border spinner-border-sm me-2"
//                       role="status"
//                       aria-hidden="true"
//                     ></span>
//                     Processing...
//                   </>
//                 ) : (
//                   "Add Doctor & Complete"
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddHospitalDoctor;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import ProgressStepper from "../visitConstant/ProgressSteppers/ProgressStepper";
import UserSearchDropdown from "../CustomDropdown/UserSearchDropdown";
import apiHelper from "../ApiHelpar/apiHelper";
import useDebounce from "../useDebounce/useDebounce";
import { GRT_HOSPITA_BY_NAME_ID } from "../visitConstant/ApiConstant";
import BranchSearchDropdown from "../BranchSearchDropDown/BranchSearchDropDown";
import DrSearchDropDown from "../BranchSearchDropDown/DrSearchDropDown";
import DrSuchDetailedInfo from "../BranchSearchDropDown/DrSuchDetailedInfo";

const AddHospitalDoctor = ({
  hospitalId,
  BaranchId,
  Role,
  RefreshApi,
  setRefreshApi,
}) => {
  const navigate = useNavigate();

  // State management with proper typing
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [hospitalList, setHospitalList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctorList, setDoctorList] = useState([]);

  // Credential states
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  // UI states
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Search inputs
  const [hospitalSearch, setHospitalSearch] = useState("");
  const [doctorSearch, setDoctorSearch] = useState("");

  // Apply debouncing to search inputs
  const debouncedHospitalSearch = useDebounce(hospitalSearch, 500);
  const debouncedDoctorSearch = useDebounce(doctorSearch, 500);

  // Clear error when inputs change
  useEffect(() => {
    if (error) setError("");
  }, [
    selectedHospital,
    selectedBranch,
    selectedDoctor,
    userName,
    password,
    error,
  ]);

  // Fetch hospitals based on search term
  const fetchHospitals = useCallback(async () => {
    if (!debouncedHospitalSearch || debouncedHospitalSearch.trim() === "") {
      setHospitalList([]);
      return;
    }

    try {
      setLoading(true);
      const response = await apiHelper(GRT_HOSPITA_BY_NAME_ID, {
        id: hospitalId,
        name: debouncedHospitalSearch,
      });

      if (
        response?.respData?.respMsg &&
        Array.isArray(response.respData.respMsg)
      ) {
        setHospitalList(response.respData.respMsg);
      } else {
        setHospitalList([]);
        console.error("Invalid hospital data format:", response);
      }
    } catch (err) {
      console.error("Error fetching hospitals:", err);
      setError("Failed to load hospitals. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [debouncedHospitalSearch]);

  useEffect(() => {
    fetchHospitals();
  }, [fetchHospitals ]);

  // Fetch doctors based on search term
  const fetchDoctors = useCallback(async () => {
    if (!debouncedDoctorSearch || debouncedDoctorSearch.trim() === "") {
      setDoctorList([]);
      return;
    }

    try {
      setLoading(true);
      const data = {
        name: debouncedDoctorSearch,
        // Include mobile search if needed
        mobileNo: /^\d+$/.test(debouncedDoctorSearch)
          ? debouncedDoctorSearch
          : "",
      };

      const response = await apiHelper("searchDoctorByNameOrMobileNo", data);

      if (
        response?.respData?.respMsg &&
        Array.isArray(response.respData.respMsg)
      ) {
        setDoctorList(response.respData.respMsg);
      } else {
        setDoctorList([]);
        console.error("Invalid doctor data format:", response);
      }
    } catch (err) {
      console.error("Error fetching doctors:", err);
      setError("Failed to load doctors. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [debouncedDoctorSearch]);

  useEffect(() => {
    fetchDoctors();
  }, [fetchDoctors]);

  // Update when hospital is selected
  useEffect(() => {
    if (selectedHospital) {
      setHospitalSearch(selectedHospital.name);
      // Reset branch when hospital changes
      setSelectedBranch(null);
    }
  }, [selectedHospital]);

  // Update doctor search when doctor is selected
  useEffect(() => {
    if (selectedDoctor) {
      if (typeof setDoctorSearch === "function") {
        setDoctorSearch(selectedDoctor.name || "");
      }

      // Optionally set username based on doctor name
      if (!userName && selectedDoctor.name) {
        const suggestedUsername = selectedDoctor.name
          .toLowerCase()
          .replace(/\s+/g, ".");
        // setUserName(suggestedUsername);
      }
    }
  }, [selectedDoctor]);

  // Handle doctor selection from the DrSearchDropDown component
  const handleDoctorSelect = useCallback((doctor) => {
    setSelectedDoctor(doctor);

    if (typeof doctor === "object" && doctor !== null && doctor.name) {
      setDoctorSearch(doctor.name);
    }
  }, []);

  // Validate form data
  const validateForm = () => {
    if (!selectedHospital) {
      setError("Please select a hospital");
      return false;
    }

    if (!selectedBranch) {
      setError("Please select a branch");
      return false;
    }

    if (!selectedDoctor) {
      setError("Please select a doctor");
      return false;
    }

    if (!userName.trim()) {
      setError("Username is required");
      return false;
    }

    if (!password.trim()) {
      setError("Password is required");
      return false;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      return false;
    }

    return true;
  };

  // Form submission handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const requestData = {
        branchId: selectedBranch,
        doctorID: selectedDoctor.doctors,
        customer: selectedDoctor,
        username: userName,
        password: password,
        role: "ROLE_DOCTOR",
        startDate: moment().format("YYYY-MM-DD"),
      };

      console.log(requestData);
      const response = await apiHelper("addHospitalDoctor", requestData);

      // console.log(response);

      if (response?.respInfo?.message === "Success") {
        setSuccess("Doctor added successfully to the branch");

        // Clear form after success
        setSelectedHospital(null);
        setSelectedBranch(null);
        setSelectedDoctor(null);
        setUserName("");
        setPassword("");
        setHospitalSearch("");
        setDoctorSearch("");
      
  setRefreshApi(!RefreshApi)
      } else {
        throw new Error(response?.respInfo?.message || "Failed to add doctor");
      }
    } catch (err) {
      console.error("Error adding doctor:", err);
      setError(err.message || "Error adding doctor. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };

  return (
    <div className="justify-content-center w-100" style={{ maxWidth: 700 }}>
      {/* <ProgressStepper currentSteps={4} /> */}
      <div className="card mx-auto">
        <div className="card-header">
          <h4 className="mb-0">Add Doctor to Branch</h4>
        </div>
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <form onSubmit={handleSubmit}>
            {/* Hospital Selection */}
            <div className="mb-3">
              <label className="form-label">Hospital*</label>
              <UserSearchDropdown
                options={hospitalList}
                handleInputChange={setHospitalSearch}
                onSelect={setSelectedHospital}
                value={selectedHospital}
                loading={loading && debouncedHospitalSearch !== ""}
                Placeholder="Search hospital by name"
                searchTerm={hospitalSearch}
                newEntry={false}
                UserSearchDrop={false}
                displayKey={(option) => option?.name || ""}
              />
              {hospitalSearch && hospitalList.length === 0 && !loading && (
                <div className="form-text text-muted">
                  No hospitals found. Try a different search term.
                </div>
              )}
            </div>

            {/* Branch Selection */}
            <div className="mb-3">
              <label className="form-label">Branch*</label>
              {selectedHospital ? (
                <BranchSearchDropdown
                  hospitalId={selectedHospital?.id}
                  onSelect={setSelectedBranch}
                  selectedBranchId={selectedBranch?.id}
                />
              ) : (
                <div className="form-text text-muted">
                  Please select a hospital first to view branches.
                </div>
              )}
            </div>

            {/* Doctor Selection */}
            <div className="mb-3">
              <label className="form-label">Doctor*</label>
              {selectedBranch ? (
                <DrSuchDetailedInfo
                  onSelect={handleDoctorSelect}
                  // hospitalId={selectedHospital?.id || 0}
                  type="doctor"
                  branchId={selectedBranch?.id}
                  value={selectedDoctor}
                />
              ) : (
                <div className="form-text text-muted">
                  Please select a branch first to search for doctors.
                </div>
              )}
            </div>

            {/* Username Input */}
            <div className="mb-3">
              <label className="form-label">Username*</label>
              <input
                type="text"
                className="form-control"
                value={userName}
                onChange={handleInputChange(setUserName)}
                placeholder="Enter username for doctor login"
                required
              />
              <div className="form-text">
                Username will be used by the doctor to login to the system
              </div>
            </div>

            {/* Password Input */}
            <div className="mb-3">
              <label className="form-label">Password*</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={handleInputChange(setPassword)}
                placeholder="Enter password"
                required
                minLength={6}
              />
              <div className="form-text">
                Password must be at least 6 characters long
              </div>
            </div>

            {/* Form Actions */}
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <button
                type="button"
                className="btn btn-outline-info me-md-2"
                onClick={() => navigate("/drsignup")}
                disabled={loading}
              >
                Back
              </button>
              <button
                type="submit"
                className="btn btn-primary text-light"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  " Submit "
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddHospitalDoctor;
